import Swiper, { Navigation } from 'swiper';
import YTPlayer from 'youtube-player';

Swiper.use([Navigation]);

export default {
  init() {
  },
  finalize() {

    /**
     * Intro video
     */

     let $videoEl  = $('.service-intro-media .yt-player');

     if ($videoEl.length) {
       let videoElId = $videoEl.attr('id'),
           videoId   = $videoEl.data('video-id'),
           videoPlayer;

       videoPlayer = new YTPlayer(videoElId, {
         videoId: videoId,
         playerVars: {
           controls:       1,
           showinfo:       0,
           rel:            0,
           autoplay:       0,
           loop:           1,
           mute:           0,
           fs:             0,
           modestbranding: 1,
         },
       });
     }


    /**
     * Work examples slider
     */

    new Swiper('#service-work .swiper-container', {
      speed: 400,
      loop: false,
      slidesPerView: 1.1,
      spaceBetween: 30,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      breakpoints: {
        768: { // md
          slidesPerView: 2.1,
        },
      },
    });

  },
};



// WEBPACK FOOTER //
// ./scripts/routes/single-service.js